import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { ChartIcon, FileTextIcon, UsersIcon, LogOutIcon, DatabaseIcon, LayersIcon, CrownIcon } from './Icons';

function Dashboard({ user, onLogout }) {
  const location = useLocation();

  return (
    <div className="dashboard">
      <aside className="sidebar">
        <div style={{ 
          padding: '20px',
          borderBottom: '1px solid #252641',
          marginBottom: '20px'
        }}>
          <div style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '12px'
          }}>
            <img 
              src="/nexa-logo.png" 
              alt="NEXA RP" 
              style={{ 
                width: '80px', 
                height: '80px', 
                objectFit: 'contain'
              }}
            />
          </div>
          <h2 style={{ 
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            margin: 0
          }}>
            <ChartIcon size={24} />
            NexaLogs
          </h2>
        </div>
        <nav>
          <ul className="nav-menu">
            <li>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                <FileTextIcon size={20} />
                Logs
              </Link>
            </li>
            {user.role === 'admin' && (
              <>
                <li>
                  <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>
                    <UsersIcon size={20} />
                    Gestion Utilisateurs
                  </Link>
                </li>
                <li>
                  <Link to="/vip" className={location.pathname === '/vip' ? 'active' : ''}>
                    <CrownIcon size={20} />
                    Gestion VIP
                  </Link>
                </li>
                <li>
                  <Link to="/script-permissions" className={location.pathname === '/script-permissions' ? 'active' : ''}>
                    <LayersIcon size={20} />
                    Permissions Scripts
                  </Link>
                </li>
                <li>
                  <Link to="/actions-dev" className={location.pathname === '/actions-dev' ? 'active' : ''}>
                    <DatabaseIcon size={20} />
                    Actions Dev
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
        <div className="user-info">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            {user.discord_avatar ? (
              <img
                src={`https://cdn.discordapp.com/avatars/${user.discord_id}/${user.discord_avatar}.png`}
                alt={user.discord_username}
                style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '50%'
                }}
              />
            ) : (
              <div
                style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '50%',
                  background: '#374151',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#9ca3af',
                  fontWeight: 'bold',
                  fontSize: '18px'
                }}
              >
                {(user.discord_username || user.username || 'U')[0].toUpperCase()}
              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <p style={{ fontWeight: 'bold', fontSize: '14px', color: '#e5e7eb', margin: 0 }}>
                {user.discord_username || user.username}
              </p>
              <span className={`role-badge ${user.role}`}>{user.role}</span>
            </div>
          </div>
          <button className="btn-logout" onClick={onLogout}>
            <LogOutIcon size={18} />
            Déconnexion
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Dashboard;
